var enUS = {
  decimal: '.',
  thousands: ',',
  grouping: [3],
  prefix: '$',
  suffix: ''
};
export default enUS;